import { connect } from 'react-redux';
import AnvatoVideoPlayer from './AnvatoVideoPlayer';

/**
 * Connects the React component to a Redux store.
 *
 * @param {Object} state The store state.
 * @returns {{}} The component props from state.
 */
const mapStateToProps = (state) => {
  const props = {};

  const {
    tve: {
      provider,
    },
  } = state;

  if ('Comcast_SSO' === provider) {
    /**
     * It's assumed that TVE authentication will be present in state only when
     * all players on the page require authentication and must display the TVE
     * branding. In the future, we will need to account for multiple players on
     * the page with only some of them requiring authentication.
     */
    props.tve = {
      // See NXS-3089.
      link: 'https://xfinity.com/stream/',
      title: 'Xfinity',
      provider,
    };
  }

  return props;
};

export default connect(mapStateToProps)(AnvatoVideoPlayer);
